import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import axios from 'axios'; // TODO: rimuovere, usare api
import {
  ClockIcon,
  DocumentTextIcon,
  PencilIcon,
  TruckIcon,
  ClipboardDocumentListIcon,
  CurrencyEuroIcon,
  EnvelopeIcon,
  ExclamationTriangleIcon,
  EyeIcon,
  EyeSlashIcon,
  PaperAirplaneIcon,
  TrashIcon,
  PlusIcon,
  XMarkIcon,
  MagnifyingGlassIcon,
  CheckCircleIcon
} from '@heroicons/react/24/outline';
import { toast } from 'react-toastify';

const TabPreventivi = ({ 
  pratica, 
  ruoloUtente,
  isPraticaModificabileAgente,
  isInAttesaRevisione,
  onNavigaAOfferte,
  onPreventiviAggiornati,
  currentUser
}) => {
  const [preventivi, setPreventivi] = useState([]);
  const [loadingPreventivi, setLoadingPreventivi] = useState(false);
  const [loadingOperazione, setLoadingOperazione] = useState(null);
  const [preventivoInEliminazione, setPreventivoInEliminazione] = useState(null);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [mostraProvvigione, setMostraProvvigione] = useState({});
  const [provvigioniCalcolate, setProvvigioniCalcolate] = useState({});
  const [loadingProvvigioni, setLoadingProvvigioni] = useState({});

  // Stati per preventivo personalizzato
  const [showPreventivoPersonalizzato, setShowPreventivoPersonalizzato] = useState(false);
  const [preventivoPersonalizzato, setPreventivoPersonalizzato] = useState({
    idVettura: '',
    vetturaSelezionata: null,
    durata: '',
    kmAnnui: '',
    quantita: 1,
    anticipo: '',
    penaleKasko: '',
    penaleKaskoTipo: 'euro', // 'euro' o 'percentuale'
    penaleRCA: '',
    penaleRCATipo: 'euro',
    penaleFurto: '',
    penaleFurtoTipo: 'euro',
    statoDisponibilita: 'Ordine',
    tipoCliente: '',
    servizi: [],
    coloreVettura: '',
    settimaneConsegnaVettura: '',
    optionalVettura: '',
    note: ''
  });
  
  // Stati per modifica preventivo
  const [showModificaPreventivoModal, setShowModificaPreventivoModal] = useState(false);
  const [preventivoInModifica, setPreventivoInModifica] = useState(null);
  // Cambio vettura in revisione (solo admin): vettura scelta + a chi assegnare la selezione dal picker
  const [nuovaVetturaModifica, setNuovaVetturaModifica] = useState(null);
  const [selezioneVetturaPer, setSelezioneVetturaPer] = useState('creazione'); // 'creazione' | 'modifica'
  const [datiPreventivoModifica, setDatiPreventivoModifica] = useState({
    // Campi principali
    durata: '',
    kmAnnui: '',
    quantita: 1,
    anticipo: '',
    canone: '',
    provvigione: '',
    societaNoleggio: '',
    
    // Penali
    penaleKasko: '',
    penaleKaskoTipo: 'euro',
    penaleRCA: '',
    penaleRCATipo: 'euro',
    penaleFurto: '',
    penaleFurtoTipo: 'euro',
    
    // Altri parametri
    statoDisponibilita: '',
    tipoCliente: '',
    coloreVettura: '',
    settimaneConsegnaVettura: '',
    optionalVettura: '',
    servizi: [],
    
    // Note
    note: ''
  });
  
  // Stati per i servizi del sistema e società di noleggio
  const [serviziSistema, setServiziSistema] = useState([]);
  const [societaNoleggio, setSocietaNoleggio] = useState([]);
  const [loadingSocietaNoleggio, setLoadingSocietaNoleggio] = useState(false);
  const [loadingCreazionePreventivoPersonalizzato, setLoadingCreazionePreventivoPersonalizzato] = useState(false);
  const [showSelezioneVetturaPersonalizzata, setShowSelezioneVetturaPersonalizzata] = useState(false);
  const [vetturePersonalizzate, setVetturePersonalizzate] = useState([]);
  const [loadingVetturePersonalizzate, setLoadingVetturePersonalizzate] = useState(false);
  const [marcheVetture, setMarcheVetture] = useState([]);
  const [categorieVetture, setCategorieVetture] = useState([]);
  const [tipiVetture, setTipiVetture] = useState([]);
  const [filtriVetturePersonalizzate, setFiltriVetturePersonalizzate] = useState({
    search: '',
    marca_id: '',
    categoria_id: '',
    tipo_id: '',
    carburante: '',
    cambio: '',
    prezzo_min: '',
    prezzo_max: ''
  });
  const [totalPagesVetture, setTotalPagesVetture] = useState(1);
  const [currentPageVetture, setCurrentPageVetture] = useState(1);
  const [totalResultsVetture, setTotalResultsVetture] = useState(0);

  // Carica i preventivi quando si attiva il tab
  useEffect(() => {
    if (pratica?.id) {
      fetchPreventivi();
    }
  }, [pratica?.id]);

  // Applica automaticamente i filtri quando cambiano (con debounce)
  useEffect(() => {
    if (showSelezioneVetturaPersonalizzata) {
      const timeoutId = setTimeout(() => {
        fetchVetturePersonalizzate(1);
      }, 500);
      return () => clearTimeout(timeoutId);
    }
  }, [filtriVetturePersonalizzate, showSelezioneVetturaPersonalizzata]);

  // Funzioni identiche all'originale
  const fetchPreventivi = async () => {
    setLoadingPreventivi(true);
    try {
      const response = await fetch(`/api/pratica/${pratica.id}/preventivi`);
      
      if (response.ok) {
        const data = await response.json();
        
        // Il backend restituisce {success: true, preventivi: [...]}
        let preventivi = [];
        if (data && data.success && data.preventivi && Array.isArray(data.preventivi)) {
          preventivi = data.preventivi;
        } else if (Array.isArray(data)) {
          // Fallback se fosse un array diretto
          preventivi = data;
        }
        
        setPreventivi(preventivi);
// console.log(`✅ Caricati ${preventivi.length} preventivi per pratica ${pratica.id}`);
      } else {
        console.error('Errore nel caricamento preventivi:', response.status);
        setPreventivi([]);
      }
    } catch (error) {
      console.error('Errore nel caricamento preventivi:', error);
      setPreventivi([]);
    } finally {
      setLoadingPreventivi(false);
    }
  };

  // Funzione per calcolare la provvigione corretta usando l'API
  const calcolaProvvigionePreventivo = async (preventivo) => {
    const preventivoId = preventivo.id;
    
    if (loadingProvvigioni[preventivoId]) return;
    
    setLoadingProvvigioni(prev => ({ ...prev, [preventivoId]: true }));
    
    try {
      const datiOfferta = parseDatiOfferta(preventivo.datiOfferta);
      
      // Simula un contratto temporaneo per il calcolo delle provvigioni
      const contrattoTemp = {
        id: `temp_preventivo_${preventivoId}`,
        canone: datiOfferta.canone,
        durata: datiOfferta.durata,
        provvigione: datiOfferta.provvigione || 0,
        offertaId: preventivo.idOfferta,
        preventivoId: preventivoId,
        importoTotale: parseFloat(datiOfferta.canone || 0) * parseInt(datiOfferta.durata || 1)
      };

// console.log('📊 Calcolo provvigioni per preventivo:', contrattoTemp);

      const response = await api.post(
        '/provvigioni-contratti/calcola-distribuzione',
        { contratto: contrattoTemp },
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        }
      );

      if (response.data.success) {
        // Normalizza i dati per gestire sia admin che non admin
        const dataProvvigioni = response.data.data;
        const provvigioneDisplay = dataProvvigioni.provvigioneTotale || dataProvvigioni.provvigionePersonale || 0;
        
        setProvvigioniCalcolate(prev => ({
          ...prev,
          [preventivoId]: {
            ...dataProvvigioni,
            provvigioneTotale: provvigioneDisplay // Normalizza per il display
          }
        }));
        console.log(`✅ Provvigioni calcolate per preventivo ${preventivoId}:`, dataProvvigioni);
      } else {
        throw new Error(response.data.message || 'Errore nel calcolo delle provvigioni');
      }
    } catch (error) {
      console.error('❌ Errore calcolo provvigioni preventivo:', error);
      toast.error('Errore nel calcolo delle provvigioni: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoadingProvvigioni(prev => ({ ...prev, [preventivoId]: false }));
    }
  };

  const aggiornaStatoPreventivo = async (preventivoId, nuovoStato, note = '') => {
    try {
      const response = await fetch(`/api/pratica/${pratica.id}/preventivi/${preventivoId}/stato`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 
          stato: nuovoStato,
          note: note
        })
      });

      if (response.ok) {
        await fetchPreventivi();
        toast.success('Stato preventivo aggiornato con successo!');
      } else {
        const error = await response.json();
        toast.error(`Errore nell'aggiornamento: ${error.error}`);
      }
    } catch (error) {
      console.error('Errore nell\'aggiornamento stato preventivo:', error);
      toast.error('Errore di connessione');
    }
  };

  const aggiornaInvioCliente = async (preventivoId, inviato) => {
    try {
      const response = await fetch(`/api/pratica/${pratica.id}/preventivi/${preventivoId}/stato`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ inviato_al_cliente: inviato })
      });

      if (response.ok) {
        await fetchPreventivi();
        toast.success(inviato ? 'Preventivo marcato come inviato al cliente' : 'Preventivo marcato come non inviato');
      } else {
        const error = await response.json();
        toast.error(`Errore nell'aggiornamento: ${error.error}`);
      }
    } catch (error) {
      console.error('Errore nell\'aggiornamento invio cliente:', error);
      toast.error('Errore di connessione');
    }
  };

  const isPreventivoAzioniDisponibili = (preventivo) => {
    return preventivo.statoPreventivo !== 'bozza';
  };

  // Funzione separata per il PDF - sempre disponibile
  const isPreventivoDownloadDisponibile = (preventivo) => {
    return true; // PDF sempre scaricabile
  };

  // Funzione per scaricare il PDF del preventivo con template agenzia
  const downloadPreventivoConTemplate = async (preventivo) => {
    try {
// console.log(`📄 Avvio download PDF preventivo ${preventivo.id}`);
      
      // Mostra un indicatore di caricamento
      toast.info('Generazione PDF in corso...', { autoClose: 2000 });
      
      const response = await fetch(`/api/pratica/${pratica.id}/preventivi/${preventivo.id}/download`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Errore nel download del PDF');
      }

      // Converte la risposta in blob
      const pdfBlob = await response.blob();
      
      // Crea un URL per il blob del PDF
      const pdfUrl = window.URL.createObjectURL(pdfBlob);

      // Crea un link temporaneo per il download
      const link = document.createElement('a');
      link.href = pdfUrl;
      
      // Estrai il nome del file dall'header Content-Disposition se disponibile
      const disposition = response.headers.get('content-disposition');
      let filename = `preventivo_${preventivo.id}_${new Date().toISOString().split('T')[0]}.pdf`;
      
      if (disposition) {
        const filenameMatch = disposition.match(/filename="(.+)"/);
        if (filenameMatch) {
          filename = filenameMatch[1];
        }
      }
      
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      
      // Pulizia
      document.body.removeChild(link);
      window.URL.revokeObjectURL(pdfUrl);
      
      toast.success('PDF scaricato con successo!');
// console.log(`✅ PDF scaricato: ${filename}`);
      
    } catch (error) {
      console.error('❌ Errore download PDF preventivo:', error);
      
      let errorMessage = 'Errore nel download del PDF';
      if (error.message) {
        errorMessage = error.message;
      }
      
      toast.error(errorMessage);
    }
  };

  // Funzione per inviare il preventivo al cliente via email
  const inviaEmailPreventivo = async (preventivo) => {
    try {
// console.log(`📧 Avvio invio email preventivo ${preventivo.id}`);
      
      // Mostra un indicatore di caricamento
      toast.info('Invio email in corso...', { autoClose: 2000 });
      
      const response = await fetch(`/api/pratica/${pratica.id}/preventivi/${preventivo.id}/invia-cliente`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          note: 'Preventivo inviato tramite interfaccia web'
        })
      });

      const data = await response.json();

      if (response.ok && data.success) {
        toast.success(`Preventivo inviato a ${data.preventivo.emailCliente}`);
        
        // Aggiorna lo stato locale del preventivo
        setPreventivi(prevPreventivi => 
          prevPreventivi.map(p => 
            p.id === preventivo.id 
              ? { ...p, inviato_al_cliente: true, dataInvio: new Date() }
              : p
          )
        );
        
// console.log(`✅ Email inviata per preventivo ${preventivo.id}`);
      } else {
        throw new Error(data.error || 'Errore nell\'invio dell\'email');
      }
      
    } catch (error) {
      console.error('❌ Errore invio email preventivo:', error);
      
      let errorMessage = 'Errore nell\'invio dell\'email';
      if (error.message) {
        errorMessage = error.message;
      }
      
      toast.error(errorMessage);
    }
  };

  const eliminaPreventivo = async (preventivoId) => {
    const confermaEliminazione = () => {
      toast.dismiss();
      
      const conferma = toast(
        ({ closeToast }) => (
          <div>
            <p className="mb-3">Sei sicuro di voler eliminare questo preventivo?</p>
            <div className="flex space-x-2">
              <button
                onClick={() => {
                  closeToast();
                  procediEliminazione(preventivoId);
                }}
                className="px-3 py-1 bg-red-600 text-white rounded text-sm hover:bg-red-700"
              >
                Elimina
              </button>
              <button
                onClick={closeToast}
                className="px-3 py-1 bg-gray-300 text-gray-700 rounded text-sm hover:bg-gray-400"
              >
                Annulla
              </button>
            </div>
          </div>
        ),
        {
          position: "top-center",
          autoClose: false,
          hideProgressBar: true,
          closeOnClick: false,
          draggable: false,
        }
      );
    };
    
    const procediEliminazione = async (preventivoId) => {
      try {
        const response = await fetch(`/api/pratica/${pratica.id}/preventivi/${preventivoId}`, {
          method: 'DELETE'
        });

        if (response.ok) {
          await fetchPreventivi();
          toast.success('Preventivo eliminato con successo!');
          if (onPreventiviAggiornati) {
            onPreventiviAggiornati();
          }
        } else {
          const error = await response.json();
          toast.error(`Errore nell'eliminazione: ${error.error}`);
        }
      } catch (error) {
        console.error('Errore nell\'eliminazione preventivo:', error);
        toast.error('Errore di connessione');
      }
    };
    
    confermaEliminazione();
  };

  const isPreventivoPersonalizzatoAbilitato = () => {
// console.log('🔍 Debug Preventivo Personalizzato:');
// console.log('- Pratica completa:', pratica);
// console.log('- pratica.stato:', pratica?.stato);
// console.log('- pratica.statoPratica:', pratica?.statoPratica);
    
    // Usa lo stesso pattern del TabRiepilogo
    const statoEffettivo = pratica?.stato || pratica?.statoPratica;
// console.log('- Stato effettivo:', statoEffettivo);
// console.log('- isPraticaModificabileAgente():', isPraticaModificabileAgente ? isPraticaModificabileAgente() : 'non definita');
// console.log('- isInAttesaRevisione():', isInAttesaRevisione ? isInAttesaRevisione() : 'non definita');
    
    // Condizioni più permissive per il test
    const statiPermessi = [
      'pratica_avviata', 
      'documenti_ricevuti',
      'nuovo',
      'assegnato',
      'in_lavorazione'
    ];
    
    const statoOk = statiPermessi.includes(statoEffettivo);
// console.log('- Stato permesso:', statoOk);
    
    return statoOk;
  };

  const openPreventivoPersonalizzato = async () => {
    // Carica i servizi del sistema se non già caricati
    if (serviziSistema.length === 0) {
      await fetchServiziSistema();
    }
    
    // Reset del form
    setPreventivoPersonalizzato({
      idVettura: '',
      vetturaSelezionata: null,
      durata: '36',
      kmAnnui: '15000',
      anticipo: '0',
      penaleKasko: '',
      penaleKaskoTipo: 'euro',
      penaleRCA: '',
      penaleRCATipo: 'euro',
      penaleFurto: '',
      penaleFurtoTipo: 'euro',
      statoDisponibilita: 'Ordine',
      tipoCliente: pratica?.cliente?.tipo_cliente || '',
      servizi: [],
      coloreVettura: '',
      settimaneConsegnaVettura: '',
      optionalVettura: '',
      note: ''
    });
    setShowPreventivoPersonalizzato(true);
  };

  const closePreventivoPersonalizzato = () => {
    setShowPreventivoPersonalizzato(false);
  };

  const handlePreventivoPersonalizzatoChange = (field, value) => {
    setPreventivoPersonalizzato(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Funzione per caricare i servizi del sistema
  const fetchServiziSistema = async () => {
    try {
      const response = await fetch('/api/offerte-vetture/config/campi-presets');
      if (response.ok) {
        const data = await response.json();
        setServiziSistema(data.presets?.servizi || []);
      }
    } catch (error) {
      console.error('Errore nel caricamento servizi:', error);
    }
  };

  // Funzione per aprire la selezione vettura personalizzata
  const openSelezioneVetturaPersonalizzata = async () => {
    setLoadingVetturePersonalizzate(true);
    setCurrentPageVetture(1);
    setFiltriVetturePersonalizzate({
      search: '',
      marca_id: '',
      categoria_id: '',
      tipo_id: '',
      carburante: '',
      cambio: '',
      prezzo_min: '',
      prezzo_max: ''
    });
    
    try {
      // Carica marche, categorie e tipi
      await Promise.all([
        fetchMarcheVetture(),
        fetchCategorieVetture(),
        fetchTipiVetture()
      ]);
      
      // Carica le vetture
      await fetchVetturePersonalizzate();
      setShowSelezioneVetturaPersonalizzata(true);
    } catch (error) {
      console.error('Errore nel caricamento vetture:', error);
      toast.error('Errore nel caricamento delle vetture');
    } finally {
      setLoadingVetturePersonalizzate(false);
    }
  };

  // Funzioni per caricare i dati di supporto
  const fetchMarcheVetture = async () => {
    try {
      const response = await fetch('/api/vetture/marche');
      if (response.ok) {
        const data = await response.json();
        setMarcheVetture(data);
      }
    } catch (error) {
      console.error('Errore nel caricamento marche:', error);
    }
  };

  const fetchCategorieVetture = async () => {
    try {
      const response = await fetch('/api/vetture/categorie');
      if (response.ok) {
        const data = await response.json();
        setCategorieVetture(data);
      }
    } catch (error) {
      console.error('Errore nel caricamento categorie:', error);
    }
  };

  const fetchTipiVetture = async () => {
    try {
      const response = await fetch('/api/vetture/tipi');
      if (response.ok) {
        const data = await response.json();
        setTipiVetture(data);
      }
    } catch (error) {
      console.error('Errore nel caricamento tipi:', error);
    }
  };

  // Funzione per caricare le vetture con filtri
  const fetchVetturePersonalizzate = async (page = 1) => {
    setLoadingVetturePersonalizzate(true);
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: '20',
        ...filtriVetturePersonalizzate
      });

      const response = await fetch(`/api/vetture/vetture?${params}`);
      if (response.ok) {
        const data = await response.json();
        setVetturePersonalizzate(data.vehicles || data.data || []);
        setTotalPagesVetture(data.totalPages || 1);
        setCurrentPageVetture(data.currentPage || page);
        setTotalResultsVetture(data.total || 0);
      } else {
        toast.error('Errore nel caricamento delle vetture');
      }
    } catch (error) {
      console.error('Errore nel caricamento vetture:', error);
      toast.error('Errore nel caricamento delle vetture');
    } finally {
      setLoadingVetturePersonalizzate(false);
    }
  };

  // Funzione per gestire i cambi di filtro
  const handleFiltroVetturaChange = (name, value) => {
    setFiltriVetturePersonalizzate(prev => ({
      ...prev,
      [name]: value
    }));
    setCurrentPageVetture(1);
  };

  // Funzione per resettare i filtri
  const resetFiltriVetture = () => {
    setFiltriVetturePersonalizzate({
      search: '',
      marca_id: '',
      categoria_id: '',
      tipo_id: '',
      carburante: '',
      cambio: '',
      prezzo_min: '',
      prezzo_max: ''
    });
    setCurrentPageVetture(1);
    // I filtri si applicheranno automaticamente tramite useEffect
  };

  // Funzione per cambiare pagina
  const handlePageChangeVetture = (page) => {
    setCurrentPageVetture(page);
    fetchVetturePersonalizzate(page);
  };

  // Funzione per selezionare una vettura personalizzata (creazione) o per la revisione (admin)
  const selezionaVetturaPersonalizzata = (vettura) => {
    if (selezioneVetturaPer === 'modifica') {
      setNuovaVetturaModifica(vettura);
      setSelezioneVetturaPer('creazione');
    } else {
      setPreventivoPersonalizzato(prev => ({
        ...prev,
        idVettura: vettura.id,
        vetturaSelezionata: vettura
      }));
    }
    setShowSelezioneVetturaPersonalizzata(false);
  };

  // Admin: apre il picker vetture per cambiare la vettura del preventivo in revisione
  const openCambioVetturaModifica = async () => {
    setSelezioneVetturaPer('modifica');
    await openSelezioneVetturaPersonalizzata();
  };

  const handleServiziChange = (servizio, checked) => {
    setPreventivoPersonalizzato(prev => ({
      ...prev,
      servizi: checked 
        ? [...prev.servizi, servizio]
        : prev.servizi.filter(s => s !== servizio)
    }));
  };

  const creaPreventivoPersonalizzato = async () => {
    // Validazione campi obbligatori
    if (!preventivoPersonalizzato.idVettura) {
      toast.error('Seleziona una vettura');
      return;
    }

    if (!preventivoPersonalizzato.durata || !preventivoPersonalizzato.kmAnnui) {
      toast.error('Durata e chilometri annui sono obbligatori');
      return;
    }

    setLoadingCreazionePreventivoPersonalizzato(true);
    
    try {
      // Prepara i dati con il tipo cliente automatico dalla pratica
      const datiPersonalizzati = {
        ...preventivoPersonalizzato,
        tipoCliente: pratica?.cliente?.tipo_cliente || '',
        // Formatta le penali con il tipo
        penaleKasko: preventivoPersonalizzato.penaleKasko ? 
          (preventivoPersonalizzato.penaleKaskoTipo === 'percentuale' ? 
            `-${preventivoPersonalizzato.penaleKasko}` : 
            preventivoPersonalizzato.penaleKasko) : '',
        penaleRCA: preventivoPersonalizzato.penaleRCA ? 
          (preventivoPersonalizzato.penaleRCATipo === 'percentuale' ? 
            `-${preventivoPersonalizzato.penaleRCA}` : 
            preventivoPersonalizzato.penaleRCA) : '',
        penaleFurto: preventivoPersonalizzato.penaleFurto ? 
          (preventivoPersonalizzato.penaleFurtoTipo === 'percentuale' ? 
            `-${preventivoPersonalizzato.penaleFurto}` : 
            preventivoPersonalizzato.penaleFurto) : ''
      };

      const response = await fetch(`/api/pratica/${pratica.id}/preventivi`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          tipoPreventivo: 'personalizzato',
          datiPersonalizzati: datiPersonalizzati,
          note: `Preventivo personalizzato: ${preventivoPersonalizzato.vetturaSelezionata?.marca?.descrizione || ''} ${preventivoPersonalizzato.vetturaSelezionata?.modello || ''}${preventivoPersonalizzato.note ? ` - ${preventivoPersonalizzato.note}` : ''}`,
          creatoDA: currentUser?.nome || 'Sistema'
        })
      });

      if (response.ok) {
        await fetchPreventivi();
        if (onPreventiviAggiornati) {
          onPreventiviAggiornati();
        }
        setShowPreventivoPersonalizzato(false);
        toast.success('Preventivo personalizzato creato con successo! La pratica è ora in attesa di revisione.');
      } else {
        const error = await response.json();
        toast.error(`Errore nella creazione del preventivo: ${error.error}`);
      }
    } catch (error) {
      console.error('Errore nella creazione del preventivo personalizzato:', error);
      toast.error('Errore di connessione nella creazione del preventivo');
    } finally {
      setLoadingCreazionePreventivoPersonalizzato(false);
    }
  };

  const openModificaPreventivo = async (preventivo = null) => {
    let preventivoSelezionato = null;
    
    if (preventivo) {
      // Verifica che sia un preventivo personalizzato
      if (preventivo.tipoPreventivo !== 'personalizzato') {
        toast.error('Solo i preventivi personalizzati possono essere modificati');
        return;
      }
      
      // Verifica permessi per agenti
      if (ruoloUtente === 'agente') {
        // L'agente può modificare solo i preventivi che ha creato lui
        if (preventivo.creatoDA !== currentUser?.nome) {
          toast.error('Puoi modificare solo i preventivi che hai creato tu');
          return;
        }
      }
      
      preventivoSelezionato = preventivo;
    } else {
      // Se non c'è un preventivo specifico, prendi il primo personalizzato in attesa o in bozza
      preventivoSelezionato = preventivi.find(p => 
        (p.statoPreventivo === 'in_attesa' || p.statoPreventivo === 'bozza') && 
        p.tipoPreventivo === 'personalizzato'
      );
      if (!preventivoSelezionato) {
        toast.error('Nessun preventivo personalizzato disponibile per la modifica');
        return;
      }
    }
    
    setPreventivoInModifica(preventivoSelezionato);
    setNuovaVetturaModifica(null);
    
    // Carica le società di noleggio e i servizi del sistema
    await Promise.all([
      fetchSocietaNoleggio(),
      fetchServiziSistema()
    ]);
    
    // Inizializza i dati di modifica
    const datiOfferta = typeof preventivoSelezionato.datiOfferta === 'string' 
      ? JSON.parse(preventivoSelezionato.datiOfferta) 
      : preventivoSelezionato.datiOfferta || {};
      
    setDatiPreventivoModifica({
      // Campi principali
      durata: datiOfferta.durata || '',
      kmAnnui: datiOfferta.kmAnnui || '',
      quantita: datiOfferta.quantita || 1,
      anticipo: datiOfferta.anticipo || '',
      canone: datiOfferta.canone || '',
      provvigione: datiOfferta.provvigione || '',
      societaNoleggio: datiOfferta.societaNoleggio || '',
      
      // Penali
      penaleKasko: datiOfferta.penaleKasko || '',
      penaleKaskoTipo: datiOfferta.penaleKaskoTipo || 'euro',
      penaleRCA: datiOfferta.penaleRCA || '',
      penaleRCATipo: datiOfferta.penaleRCATipo || 'euro',
      penaleFurto: datiOfferta.penaleFurto || '',
      penaleFurtoTipo: datiOfferta.penaleFurtoTipo || 'euro',
      
      // Altri parametri
      statoDisponibilita: datiOfferta.statoDisponibilita || '',
      tipoCliente: datiOfferta.tipoCliente || '',
      coloreVettura: datiOfferta.coloreVettura || '',
      settimaneConsegnaVettura: datiOfferta.settimaneConsegnaVettura || '',
      optionalVettura: datiOfferta.optionalVettura || '',
      servizi: datiOfferta.servizi || [],
      
      // Note
      note: preventivoSelezionato.note || ''
    });
    
    setShowModificaPreventivoModal(true);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      return new Date(dateString).toLocaleDateString('it-IT');
    } catch (error) {
      return '';
    }
  };

  // Funzione per gestire il parsing dei dati offerta - identica all'originale
  const parseDatiOfferta = (datiOffertaRaw) => {
    if (!datiOffertaRaw) return {};
    if (typeof datiOffertaRaw === 'object') return datiOffertaRaw;
    
    try {
      const firstParse = JSON.parse(datiOffertaRaw);
      if (typeof firstParse === 'string') {
        return JSON.parse(firstParse);
      }
      return firstParse;
    } catch (error) {
      console.error('Errore nel parsing dati offerta:', error);
      return {};
    }
  };

  // Funzione per caricare le società di noleggio
  const fetchSocietaNoleggio = async () => {
    setLoadingSocietaNoleggio(true);
    try {
// console.log('🏢 Caricamento società di noleggio...');
      const response = await fetch('/api/noleggio/societanoleggio', {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      
// console.log('🏢 Risposta società noleggio:', response.status);
      
      if (response.ok) {
        const data = await response.json();
// console.log('🏢 Dati società noleggio ricevuti:', data);
        
        // Gestisce diversi formati di risposta
        let societa = [];
        if (Array.isArray(data)) {
          societa = data;
        } else if (data.success && Array.isArray(data.societa)) {
          societa = data.societa;
        } else if (data.societaNoleggio && Array.isArray(data.societaNoleggio)) {
          societa = data.societaNoleggio;
        } else if (data.societa && Array.isArray(data.societa)) {
          societa = data.societa;
        }
        
// console.log('🏢 Società elaborate:', societa);
        setSocietaNoleggio(societa);
      } else {
        console.error('🏢 Errore risposta società noleggio:', response.status, response.statusText);
        setSocietaNoleggio([]);
      }
    } catch (error) {
      console.error('🏢 Errore nel caricamento società noleggio:', error);
      setSocietaNoleggio([]);
    } finally {
      setLoadingSocietaNoleggio(false);
    }
  };

  // Funzione per gestire i cambi nei dati di modifica preventivo
  const handleDatiPreventivoModificaChange = (field, value) => {
    setDatiPreventivoModifica(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Funzione per gestire i servizi nella modifica preventivo
  const handleServiziModificaChange = (servizio, checked) => {
    setDatiPreventivoModifica(prev => ({
      ...prev,
      servizi: checked 
        ? [...prev.servizi, servizio]
        : prev.servizi.filter(s => s !== servizio)
    }));
  };

  // Funzione per salvare le modifiche al preventivo
  const salvaModifichePreventivo = async () => {
    if (!preventivoInModifica) return;

    try {
      // Aggiorna i dati dell'offerta con i nuovi valori
      const datiOffertaOriginali = typeof preventivoInModifica.datiOfferta === 'string' 
        ? JSON.parse(preventivoInModifica.datiOfferta) 
        : preventivoInModifica.datiOfferta || {};
      
      const datiOffertaAggiornati = {
        ...datiOffertaOriginali,
        // Campi principali
        durata: datiPreventivoModifica.durata,
        kmAnnui: datiPreventivoModifica.kmAnnui,
        quantita: datiPreventivoModifica.quantita,
        anticipo: datiPreventivoModifica.anticipo,
        canone: datiPreventivoModifica.canone,
        provvigione: datiPreventivoModifica.provvigione,
        societaNoleggio: datiPreventivoModifica.societaNoleggio,
        
        // Penali
        penaleKasko: datiPreventivoModifica.penaleKasko,
        penaleKaskoTipo: datiPreventivoModifica.penaleKaskoTipo,
        penaleRCA: datiPreventivoModifica.penaleRCA,
        penaleRCATipo: datiPreventivoModifica.penaleRCATipo,
        penaleFurto: datiPreventivoModifica.penaleFurto,
        penaleFurtoTipo: datiPreventivoModifica.penaleFurtoTipo,
        
        // Altri parametri
        statoDisponibilita: datiPreventivoModifica.statoDisponibilita,
        tipoCliente: datiPreventivoModifica.tipoCliente,
        coloreVettura: datiPreventivoModifica.coloreVettura,
        settimaneConsegnaVettura: datiPreventivoModifica.settimaneConsegnaVettura,
        optionalVettura: datiPreventivoModifica.optionalVettura,
        servizi: datiPreventivoModifica.servizi
      };

      // Se l'admin ha cambiato la vettura, aggiorno lo snapshot in datiOfferta
      if (nuovaVetturaModifica) {
        datiOffertaAggiornati.marca = nuovaVetturaModifica.marca?.descrizione || nuovaVetturaModifica.brand || datiOffertaAggiornati.marca;
        datiOffertaAggiornati.modello = nuovaVetturaModifica.modello || datiOffertaAggiornati.modello;
        datiOffertaAggiornati.alimentazione = nuovaVetturaModifica.alimentazione || datiOffertaAggiornati.alimentazione;
        datiOffertaAggiornati.allestimento = nuovaVetturaModifica.allestimento || datiOffertaAggiornati.allestimento;
      }

      const response = await fetch(`/api/pratica/${pratica.id}/preventivi/${preventivoInModifica.id}/modifica`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          note: datiPreventivoModifica.note,
          datiOfferta: JSON.stringify(datiOffertaAggiornati),
          ...(nuovaVetturaModifica ? { idVettura: nuovaVetturaModifica.id } : {})
        })
      });

      const data = await response.json();

      if (response.ok) {
        toast.success('Preventivo modificato con successo');
        setShowModificaPreventivoModal(false);
        setPreventivoInModifica(null);
        setNuovaVetturaModifica(null);
        setDatiPreventivoModifica({
          durata: '',
          kmAnnui: '',
          anticipo: '',
          canone: '',
          provvigione: '',
          societaNoleggio: '',
          penaleKasko: '',
          penaleKaskoTipo: 'euro',
          penaleRCA: '',
          penaleRCATipo: 'euro',
          penaleFurto: '',
          penaleFurtoTipo: 'euro',
          statoDisponibilita: '',
          tipoCliente: '',
          coloreVettura: '',
          settimaneConsegnaVettura: '',
          optionalVettura: '',
          servizi: [],
          note: ''
        });
        fetchPreventivi();
        if (onPreventiviAggiornati) {
          onPreventiviAggiornati();
        }
      } else {
        toast.error(data.error || 'Errore nella modifica del preventivo');
      }
    } catch (error) {
      console.error('Errore nella modifica preventivo:', error);
      toast.error('Errore di connessione');
    }
  };

  if (!pratica) {
    return <div>Caricamento...</div>;
  }

  return (
    <div className="space-y-6">
      {/* Messaggio di attesa revisione */}
      {isInAttesaRevisione() && (
        <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <ClockIcon className="h-5 w-5 text-purple-600" />
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-purple-800">
                Pratica in Attesa di Revisione
              </h3>
              <p className="text-sm text-purple-700 mt-1">
                Un preventivo personalizzato è stato richiesto e la pratica è ora in attesa di revisione da parte dell'amministratore. 
                Non è possibile effettuare modifiche fino al completamento della revisione.
              </p>
            </div>
          </div>
        </div>
      )}

      {/* Header con stile coerente */}
      <div className="bg-white rounded-lg shadow-sm border">
        <div className="px-6 py-4 border-b bg-gray-50">
          <div className="flex justify-between items-center">
            <div>
              <h3 className="text-lg font-semibold text-gray-900">Gestione Preventivi</h3>
              <p className="text-sm text-gray-600 mt-1">
                {preventivi.length > 0 ? `${preventivi.length} preventivo${preventivi.length > 1 ? 'i' : ''} creato${preventivi.length > 1 ? 'i' : ''}` : 'Nessun preventivo presente'}
              </p>
            </div>
            <div className="flex space-x-3">
              <button 
                className={`px-4 py-2 rounded-lg flex items-center transition-colors ${
                  isPraticaModificabileAgente()
                    ? 'bg-blue-600 text-white hover:bg-blue-700'
                    : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                }`}
                onClick={isPraticaModificabileAgente() ? onNavigaAOfferte : undefined}
                disabled={!isPraticaModificabileAgente()}
                title={!isPraticaModificabileAgente() ? 'Non disponibile durante la revisione' : 'Crea preventivo da catalogo'}
              >
                <DocumentTextIcon className="h-4 w-4 mr-2" />
                Da Catalogo
              </button>
              <button 
                className={`px-4 py-2 rounded-lg flex items-center transition-colors ${
                  isPreventivoPersonalizzatoAbilitato() && isPraticaModificabileAgente()
                    ? 'bg-green-600 text-white hover:bg-green-700'
                    : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                }`}
                onClick={isPreventivoPersonalizzatoAbilitato() && isPraticaModificabileAgente() ? openPreventivoPersonalizzato : undefined}
                disabled={!isPreventivoPersonalizzatoAbilitato() || !isPraticaModificabileAgente()}
                title={
                  !isPraticaModificabileAgente() ? 'Non disponibile durante la revisione' :
                  !isPreventivoPersonalizzatoAbilitato() ? `Non disponibile per stato: "${pratica?.stato || pratica?.statoPratica || 'undefined'}". Controlla console per dettagli.` : 
                  'Crea un preventivo personalizzato'
                }
              >
                <PencilIcon className="h-4 w-4 mr-2" />
                Personalizzato
              </button>
            </div>
          </div>
        </div>
        
        <div className="p-6">
          {loadingPreventivi ? (
            <div className="text-center py-12">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto"></div>
              <p className="mt-4 text-gray-500">Caricamento preventivi...</p>
            </div>
          ) : preventivi.length > 0 ? (
            <div className="space-y-4">
              {preventivi.map((preventivo, index) => {
                const datiOfferta = parseDatiOfferta(preventivo.datiOfferta);
                
                return (
                  <div key={preventivo.id} className="border border-gray-200 rounded-lg hover:shadow-md transition-shadow">
                    {/* Header preventivo */}
                    <div className="px-6 py-4 border-b border-gray-100 bg-gray-50 rounded-t-lg">
                      <div className="flex justify-between items-center">
                        <div>
                          <div className="flex items-center gap-2 mb-1">
                            <h4 className="text-lg font-semibold text-gray-900">
                              Preventivo #{preventivo.id}
                            </h4>
                            <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                              preventivo.tipoPreventivo === 'personalizzato' 
                                ? 'bg-purple-100 text-purple-800' 
                                : 'bg-blue-100 text-blue-800'
                            }`}>
                              {preventivo.tipoPreventivo === 'personalizzato' ? 'Personalizzato' : 'Standard'}
                            </span>
                          </div>
                          <p className="text-sm text-gray-600">
                            Creato il {formatDate(preventivo.dataCreazione)} da {preventivo.creatoDA || 'Sistema'}
                          </p>
                        </div>
                        
                        <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                          preventivo.statoPreventivo === 'bozza' ? 'bg-gray-100 text-gray-800' :
                          preventivo.statoPreventivo === 'inviato' ? 'bg-blue-100 text-blue-800' :
                          preventivo.statoPreventivo === 'accettato' ? 'bg-green-100 text-green-800' :
                          preventivo.statoPreventivo === 'rifiutato' ? 'bg-red-100 text-red-800' :
                          preventivo.statoPreventivo === 'in_attesa' ? 'bg-yellow-100 text-yellow-800' :
                          'bg-gray-100 text-gray-800'
                        }`}>
                          {preventivo.statoPreventivo === 'bozza' ? 'Bozza' :
                           preventivo.statoPreventivo === 'inviato' ? 'Inviato' :
                           preventivo.statoPreventivo === 'accettato' ? 'Accettato' :
                           preventivo.statoPreventivo === 'rifiutato' ? 'Rifiutato' :
                           preventivo.statoPreventivo === 'in_attesa' ? 'In Attesa' :
                           preventivo.statoPreventivo}
                        </span>
                      </div>
                    </div>
                    
                    {/* Contenuto preventivo */}
                    <div className="p-6">
                      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
                        
                        {/* Sezione Vettura */}
                        <div>
                          <h5 className="text-sm font-semibold text-gray-900 mb-3 flex items-center">
                            <TruckIcon className="h-4 w-4 mr-2 text-gray-600" />
                            Vettura
                          </h5>
                          <div className="space-y-3">
                            {preventivo.vettura?.immagine?.path_file && (
                              <div className="w-full h-24 bg-gray-50 rounded-lg overflow-hidden border">
                                <img
                                  src={`${preventivo.vettura.immagine.path_file}`}
                                  alt={`${preventivo.vettura.brand} ${preventivo.vettura.modello}`}
                                  className="w-full h-full object-contain"
                                  onError={(e) => {
                                    e.target.style.display = 'none';
                                  }}
                                />
                              </div>
                            )}
                            <div className="space-y-2">
                              <div>
                                <span className="text-xs text-gray-500 uppercase tracking-wide">Marca</span>
                                <p className="font-medium text-gray-900">{preventivo.vettura?.brand}</p>
                              </div>
                              <div>
                                <span className="text-xs text-gray-500 uppercase tracking-wide">Modello</span>
                                <p className="font-medium text-gray-900">{preventivo.vettura?.modello}</p>
                              </div>
                              {preventivo.vettura?.allestimento && (
                                <div>
                                  <span className="text-xs text-gray-500 uppercase tracking-wide">Allestimento</span>
                                  <p className="font-medium text-gray-900">{preventivo.vettura.allestimento}</p>
                                </div>
                              )}
                              <div>
                                <span className="text-xs text-gray-500 uppercase tracking-wide">Alimentazione</span>
                                <p className="font-medium text-gray-900">{preventivo.vettura?.alimentazione}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        {/* Sezione Condizioni */}
                        <div>
                          <h5 className="text-sm font-semibold text-gray-900 mb-3 flex items-center">
                            <ClipboardDocumentListIcon className="h-4 w-4 mr-2 text-blue-600" />
                            Condizioni
                          </h5>
                          <div className="space-y-3">
                            <div className="flex justify-between items-center">
                              <span className="text-sm text-gray-600">Durata contratto</span>
                              <span className="font-semibold text-gray-900">{datiOfferta.durata} mesi</span>
                            </div>
                            <div className="flex justify-between items-center">
                              <span className="text-sm text-gray-600">Chilometri annui</span>
                              <span className="font-semibold text-gray-900">{parseInt(datiOfferta.kmAnnui || 0).toLocaleString()}</span>
                            </div>
                            {parseInt(datiOfferta.quantita || 1) > 1 && (
                              <div className="flex justify-between items-center">
                                <span className="text-sm text-gray-600">Quantità veicoli</span>
                                <span className="font-semibold text-indigo-700">{parseInt(datiOfferta.quantita)} unità</span>
                              </div>
                            )}
                            {datiOfferta.societaNoleggio?.nome && (
                              <div className="flex justify-between items-center">
                                <span className="text-sm text-gray-600">Società noleggio</span>
                                <span className="font-semibold text-gray-900">{datiOfferta.societaNoleggio.nome}</span>
                              </div>
                            )}
                          </div>
                        </div>
                        
                        {/* Sezione Importi semplificata */}
                        <div>
                          <div className="flex items-center justify-between mb-3">
                            <h5 className="text-sm font-semibold text-gray-900">
                              Importi
                            </h5>
                            <button
                              onClick={async () => {
                                const preventivoId = preventivo.id;
                                if (mostraProvvigione[preventivoId]) {
                                  setMostraProvvigione(prev => ({ ...prev, [preventivoId]: false }));
                                } else {
                                  setMostraProvvigione(prev => ({ ...prev, [preventivoId]: true }));
                                  // Calcola la provvigione se non è già stata calcolata
                                  if (!provvigioniCalcolate[preventivoId]) {
                                    await calcolaProvvigionePreventivo(preventivo);
                                  }
                                }
                              }}
                              className="p-1 text-gray-400 hover:text-gray-600 rounded-md"
                              title={mostraProvvigione[preventivo.id] ? "Nascondi provvigione" : "Calcola e mostra provvigione"}
                              disabled={loadingProvvigioni[preventivo.id]}
                            >
                              {loadingProvvigioni[preventivo.id] ? (
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-400"></div>
                              ) : mostraProvvigione[preventivo.id] ? (
                                <EyeSlashIcon className="h-4 w-4" />
                              ) : (
                                <EyeIcon className="h-4 w-4" />
                              )}
                            </button>
                          </div>
                          <div className="space-y-3">
                            {datiOfferta.canone && (
                              <div className="text-center p-4 bg-blue-50 rounded-lg border border-blue-200">
                                <div className="text-3xl font-bold text-blue-600">
                                  €{parseFloat(datiOfferta.canone || 0).toLocaleString('it-IT', {minimumFractionDigits: 0})}
                                </div>
                                <div className="text-sm text-gray-600 uppercase tracking-wide font-medium">Canone mensile{parseInt(datiOfferta.quantita || 1) > 1 ? ' (cad.)' : ''}</div>
                              </div>
                            )}
                            {datiOfferta.canone && parseInt(datiOfferta.quantita || 1) > 1 && (
                              <div className="text-center p-3 bg-indigo-50 rounded-lg border border-indigo-200">
                                <div className="text-xl font-bold text-indigo-600">
                                  €{(parseFloat(datiOfferta.canone || 0) * parseInt(datiOfferta.quantita || 1)).toLocaleString('it-IT', {minimumFractionDigits: 0})}
                                </div>
                                <div className="text-sm text-gray-600 uppercase tracking-wide font-medium">Totale mensile (×{parseInt(datiOfferta.quantita)})</div>
                              </div>
                            )}
                            {mostraProvvigione[preventivo.id] && (
                              <div className="text-center p-3 bg-green-50 rounded-lg border border-green-200">
                                {provvigioniCalcolate[preventivo.id] ? (
                                  <>
                                    <div className="text-xl font-bold text-green-600">
                                      €{parseFloat(provvigioniCalcolate[preventivo.id].provvigioneTotale || 0).toLocaleString('it-IT', {minimumFractionDigits: 2})}
                                    </div>
                                    <div className="text-xs text-gray-600 uppercase tracking-wide font-medium">PROVVIGIONE</div>
                                  </>
                                ) : null}
                              </div>
                            )}
                          </div>
                        </div>
                        
                        {/* Azioni */}
                        <div>
                          <h5 className="text-sm font-semibold text-gray-900 mb-3">Azioni</h5>
                          <div className="space-y-2">
                            {/* Pulsante Scarica PDF - Sempre attivo */}
                            <button 
                              className="w-full px-3 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center justify-center text-sm transition-colors"
                              onClick={() => downloadPreventivoConTemplate(preventivo)}
                              title="Scarica PDF preventivo"
                            >
                              <DocumentTextIcon className="h-4 w-4 mr-2" />
                              Scarica PDF
                            </button>
                            
                            {/* Pulsante Invia Email */}
                            {isPreventivoAzioniDisponibili(preventivo) ? (
                              <button 
                                className="w-full px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center justify-center text-sm transition-colors"
                                onClick={() => inviaEmailPreventivo(preventivo)}
                              >
                                <EnvelopeIcon className="h-4 w-4 mr-2" />
                                Invia Email
                              </button>
                            ) : (
                              <button 
                                className="w-full px-3 py-2 bg-gray-300 text-gray-500 rounded-lg cursor-not-allowed flex items-center justify-center text-sm"
                                disabled
                                title="Non disponibile per preventivi in bozza"
                              >
                                <EnvelopeIcon className="h-4 w-4 mr-2" />
                                Invia Email
                              </button>
                            )}
                            
                            {/* Pulsante modifica solo per preventivi personalizzati e admin */}
                            {preventivo.tipoPreventivo === 'personalizzato' && 
                             ruoloUtente === 'admin' && 
                             (preventivo.statoPreventivo === 'in_attesa' || preventivo.statoPreventivo === 'bozza') && (
                              <button 
                                className="w-full px-3 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center justify-center text-sm transition-colors"
                                onClick={() => openModificaPreventivo(preventivo)}
                              >
                                <PencilIcon className="h-4 w-4 mr-2" />
                                Modifica Preventivo
                              </button>
                            )}
                            
                            {/* Checkbox per tracciare invio al cliente */}
                            <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
                              <span className="text-sm text-gray-700">Inviato al cliente</span>
                              <label className="relative inline-flex items-center cursor-pointer">
                                <input
                                  type="checkbox"
                                  className="sr-only peer"
                                  checked={preventivo.inviato_al_cliente || false}
                                  onChange={(e) => aggiornaInvioCliente(preventivo.id, e.target.checked)}
                                  disabled={!isPraticaModificabileAgente() || preventivo.statoPreventivo === 'bozza'}
                                />
                                <div className={`w-11 h-6 ${preventivo.statoPreventivo === 'bozza' ? 'bg-gray-100' : 'bg-gray-200'} peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600 ${preventivo.statoPreventivo === 'bozza' ? 'peer-checked:bg-gray-400' : ''}`}></div>
                              </label>
                            </div>
                            {preventivo.statoPreventivo === 'bozza' && (
                              <div className="text-xs text-gray-500 text-center mt-1">
                                Le azioni di invio non sono disponibili per preventivi in bozza
                              </div>
                            )}
                            
                            {/* Pulsante Elimina */}
                            {isPraticaModificabileAgente() ? (
                              <button 
                                className="w-full px-3 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 flex items-center justify-center text-sm transition-colors"
                                onClick={() => eliminaPreventivo(preventivo.id)}
                              >
                                <svg className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                                Elimina
                              </button>
                            ) : (
                              <button 
                                className="w-full px-3 py-2 bg-gray-300 text-gray-500 rounded-lg cursor-not-allowed flex items-center justify-center text-sm"
                                disabled
                                title="Non disponibile durante la revisione"
                              >
                                <svg className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                                Elimina
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                      
                      {/* Dettagli aggiuntivi per preventivi personalizzati */}
                      {preventivo.tipoPreventivo === 'personalizzato' && (
                        <div className="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-6">
                          {/* Penali */}
                          {(datiOfferta.penaleKasko || datiOfferta.penaleRCA || datiOfferta.penaleFurto) && (
                            <div className="p-4 bg-red-50 rounded-lg border border-red-200">
                              <h6 className="text-sm font-semibold text-gray-900 mb-3 flex items-center">
                                <ExclamationTriangleIcon className="h-4 w-4 mr-2 text-red-600" />
                                Penali
                              </h6>
                              <div className="space-y-2 text-sm">
                                {datiOfferta.penaleKasko && (
                                  <div className="flex justify-between">
                                    <span className="text-gray-600">Penale Kasko</span>
                                    <span className="font-medium">
                                      {datiOfferta.penaleKaskoTipo === 'euro' ? '€' : ''}{datiOfferta.penaleKasko}{datiOfferta.penaleKaskoTipo === 'percentuale' ? '%' : ''}
                                    </span>
                                  </div>
                                )}
                                {datiOfferta.penaleRCA && (
                                  <div className="flex justify-between">
                                    <span className="text-gray-600">Penale RCA</span>
                                    <span className="font-medium">
                                      {datiOfferta.penaleRCATipo === 'euro' ? '€' : ''}{datiOfferta.penaleRCA}{datiOfferta.penaleRCATipo === 'percentuale' ? '%' : ''}
                                    </span>
                                  </div>
                                )}
                                {datiOfferta.penaleFurto && (
                                  <div className="flex justify-between">
                                    <span className="text-gray-600">Penale Furto</span>
                                    <span className="font-medium">
                                      {datiOfferta.penaleFurtoTipo === 'euro' ? '€' : ''}{datiOfferta.penaleFurto}{datiOfferta.penaleFurtoTipo === 'percentuale' ? '%' : ''}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                          
                          {/* Servizi aggiuntivi */}
                          {datiOfferta.servizi && datiOfferta.servizi.length > 0 && (
                            <div className="p-4 bg-green-50 rounded-lg border border-green-200">
                              <h6 className="text-sm font-semibold text-gray-900 mb-3">
                                Servizi Inclusi
                              </h6>
                              <div className="space-y-1">
                                {datiOfferta.servizi.map((servizio, idx) => (
                                  <div key={idx} className="text-sm text-gray-700">
                                    • {servizio}
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      
                      {/* Note preventivo */}
                      {preventivo.note && (
                        <div className="mt-4 p-3 bg-gray-50 rounded-lg">
                          <h6 className="text-sm font-semibold text-gray-900 mb-2">Note</h6>
                          <p className="text-sm text-gray-700">{preventivo.note}</p>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="text-center py-12">
              <DocumentTextIcon className="h-12 w-12 text-gray-400 mx-auto mb-4" />
              <h3 className="text-lg font-medium text-gray-900 mb-2">Nessun preventivo presente</h3>
              <p className="text-gray-500 mb-6">
                Inizia creando un preventivo da catalogo o personalizzato per questo cliente.
              </p>
              
              <div className="flex justify-center space-x-3">
                <button 
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center"
                  onClick={onNavigaAOfferte}
                >
                  <DocumentTextIcon className="h-4 w-4 mr-2" />
                  Crea da Catalogo
                </button>
                {isPreventivoPersonalizzatoAbilitato() ? (
                  <button 
                    className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center"
                    onClick={openPreventivoPersonalizzato}
                  >
                    <PencilIcon className="h-4 w-4 mr-2" />
                    Crea Personalizzato
                  </button>
                ) : (
                  <button 
                    className="px-4 py-2 bg-gray-300 text-gray-500 rounded-lg cursor-not-allowed flex items-center"
                    disabled
                    title={`Preventivo personalizzato non disponibile per stato: "${pratica?.stato || pratica?.statoPratica || 'undefined'}". Controlla console per dettagli.`}
                  >
                    <PencilIcon className="h-4 w-4 mr-2" />
                    Crea Personalizzato (Bloccato)
                  </button>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Nessun preventivo disponibile */}
      <div className="text-center py-8">
        {pratica?.statoPratica === 'pratica_avviata' && isPraticaModificabileAgente() && (
          <div className="mt-6">
            <button
              onClick={onNavigaAOfferte}
              className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <PlusIcon className="-ml-1 mr-2 h-5 w-5" />
              Vai alle Offerte
            </button>
          </div>
        )}
        {isInAttesaRevisione() && (
          <div className="mt-4 p-4 bg-yellow-50 border-l-4 border-yellow-400">
            <p className="text-sm text-yellow-700">
              Un preventivo personalizzato è stato richiesto e la pratica è ora in attesa di revisione da parte dell'amministratore.
            </p>
          </div>
        )}
      </div>

      {/* Modale Preventivo Personalizzato */}
      {showPreventivoPersonalizzato && (
        <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
          <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
            
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-6xl sm:w-full">
              {/* Header */}
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 border-b">
                <div className="flex justify-between items-center">
                  <h3 className="text-lg leading-6 font-medium text-gray-900">
                    Crea Preventivo Personalizzato
                  </h3>
                  <button
                    onClick={closePreventivoPersonalizzato}
                    className="text-gray-400 hover:text-gray-500"
                  >
                    <XMarkIcon className="h-6 w-6" />
                  </button>
                </div>
                <p className="text-sm text-gray-600 mt-2">
                  Compila i dettagli per creare un preventivo personalizzato per questa pratica
                </p>
              </div>
              
              {/* Body */}
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 max-h-[70vh] overflow-y-auto">
                <div className="space-y-6">
                  
                  {/* Sezione Selezione Vettura */}
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                      <TruckIcon className="h-5 w-5 mr-2 text-blue-600" />
                      Vettura *
                    </h4>
                    <div className="border border-gray-300 rounded-lg p-4">
                      {preventivoPersonalizzato.vetturaSelezionata ? (
                        <div className="flex items-center justify-between">
                          <div>
                            <p className="font-medium text-gray-900">
                              {preventivoPersonalizzato.vetturaSelezionata.marca?.descrizione} {preventivoPersonalizzato.vetturaSelezionata.modello}
                            </p>
                            <p className="text-sm text-gray-600">
                              {preventivoPersonalizzato.vetturaSelezionata.allestimento} - {preventivoPersonalizzato.vetturaSelezionata.alimentazione}
                            </p>
                          </div>
                          <button
                            onClick={openSelezioneVetturaPersonalizzata}
                            className="px-3 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700"
                          >
                            Cambia Vettura
                          </button>
                        </div>
                      ) : (
                        <button
                          onClick={openSelezioneVetturaPersonalizzata}
                          className="w-full px-4 py-3 border-2 border-dashed border-gray-300 rounded-lg text-gray-600 hover:border-blue-500 hover:text-blue-600 transition-colors"
                          disabled={loadingVetturePersonalizzate}
                        >
                          {loadingVetturePersonalizzate ? 'Caricamento...' : 'Seleziona Vettura'}
                        </button>
                      )}
                    </div>
                  </div>
                  
                  {/* Sezione Condizioni Contrattuali */}
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                      <ClipboardDocumentListIcon className="h-5 w-5 mr-2 text-green-600" />
                      Condizioni Contrattuali
                    </h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Durata (mesi) *</label>
                        <select
                          value={preventivoPersonalizzato.durata}
                          onChange={(e) => handlePreventivoPersonalizzatoChange('durata', e.target.value)}
                          className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        >
                          <option value="">Seleziona durata</option>
                          <option value="12">12 mesi</option>
                          <option value="24">24 mesi</option>
                          <option value="36">36 mesi</option>
                          <option value="48">48 mesi</option>
                          <option value="60">60 mesi</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Km Annui *</label>
                        <input
                          type="number"
                          value={preventivoPersonalizzato.kmAnnui}
                          onChange={(e) => handlePreventivoPersonalizzatoChange('kmAnnui', e.target.value)}
                          className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                          placeholder="Inserisci km annui"
                          min="1"
                          step="1"
                          required
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Quantità veicoli</label>
                        <input
                          type="number"
                          value={preventivoPersonalizzato.quantita}
                          onChange={(e) => handlePreventivoPersonalizzatoChange('quantita', e.target.value)}
                          className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                          placeholder="1"
                          min="1"
                          step="1"
                          title="Numero di veicoli identici per questo preventivo"
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Anticipo (€)</label>
                        <input
                          type="number"
                          value={preventivoPersonalizzato.anticipo}
                          onChange={(e) => handlePreventivoPersonalizzatoChange('anticipo', e.target.value)}
                          className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                          placeholder="0"
                          min="0"
                          step="0.01"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Penale Kasko</label>
                        <div className="flex space-x-2">
                          <input
                            type="number"
                            value={preventivoPersonalizzato.penaleKasko}
                            onChange={(e) => handlePreventivoPersonalizzatoChange('penaleKasko', e.target.value)}
                            className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            placeholder="0"
                            min="0"
                            step="0.01"
                          />
                          <select
                            value={preventivoPersonalizzato.penaleKaskoTipo}
                            onChange={(e) => handlePreventivoPersonalizzatoChange('penaleKaskoTipo', e.target.value)}
                            className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                          >
                            <option value="euro">€</option>
                            <option value="percentuale">%</option>
                          </select>
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Penale RCA</label>
                        <div className="flex space-x-2">
                          <input
                            type="number"
                            value={preventivoPersonalizzato.penaleRCA}
                            onChange={(e) => handlePreventivoPersonalizzatoChange('penaleRCA', e.target.value)}
                            className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            placeholder="0"
                            min="0"
                            step="0.01"
                          />
                          <select
                            value={preventivoPersonalizzato.penaleRCATipo}
                            onChange={(e) => handlePreventivoPersonalizzatoChange('penaleRCATipo', e.target.value)}
                            className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                          >
                            <option value="euro">€</option>
                            <option value="percentuale">%</option>
                          </select>
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Penale Furto</label>
                        <div className="flex space-x-2">
                          <input
                            type="number"
                            value={preventivoPersonalizzato.penaleFurto}
                            onChange={(e) => handlePreventivoPersonalizzatoChange('penaleFurto', e.target.value)}
                            className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            placeholder="0"
                            min="0"
                            step="0.01"
                          />
                          <select
                            value={preventivoPersonalizzato.penaleFurtoTipo}
                            onChange={(e) => handlePreventivoPersonalizzatoChange('penaleFurtoTipo', e.target.value)}
                            className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                          >
                            <option value="euro">€</option>
                            <option value="percentuale">%</option>
                          </select>
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Stato Disponibilità</label>
                        <select
                          value={preventivoPersonalizzato.statoDisponibilita}
                          onChange={(e) => handlePreventivoPersonalizzatoChange('statoDisponibilita', e.target.value)}
                          className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        >
                          <option value="Stock">Stock</option>
                          <option value="Pronta Consegna">Pronta Consegna</option>
                          <option value="Ordine">Ordine</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* Sezione Dettagli Aggiuntivi */}
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-4">Dettagli Aggiuntivi</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Tipo Cliente</label>
                        <input
                          type="text"
                          value={pratica?.cliente?.tipo_cliente || 'Non specificato'}
                          className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-gray-100 text-gray-600"
                          disabled
                          title="Automatico dalla pratica"
                        />
                        <p className="text-xs text-gray-500 mt-1">Automatico dalla pratica</p>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Colore Vettura</label>
                        <input
                          type="text"
                          value={preventivoPersonalizzato.coloreVettura}
                          onChange={(e) => handlePreventivoPersonalizzatoChange('coloreVettura', e.target.value)}
                          className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                          placeholder="Es. Nero Metallizzato"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Settimane Consegna</label>
                        <input
                          type="number"
                          value={preventivoPersonalizzato.settimaneConsegnaVettura}
                          onChange={(e) => handlePreventivoPersonalizzatoChange('settimaneConsegnaVettura', e.target.value)}
                          className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                          placeholder="Es. 4"
                          min="0"
                        />
                      </div>
                      <div className="md:col-span-3">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Optional Vettura</label>
                        <textarea
                          value={preventivoPersonalizzato.optionalVettura}
                          onChange={(e) => handlePreventivoPersonalizzatoChange('optionalVettura', e.target.value)}
                          rows="2"
                          className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                          placeholder="Descrivi gli optional inclusi..."
                        />
                      </div>
                    </div>
                  </div>
                  
                  {/* Sezione Servizi */}
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-4">Servizi Inclusi</h4>
                    {serviziSistema.length > 0 ? (
                      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                        {serviziSistema.map((servizio) => (
                          <label key={servizio} className="flex items-center">
                            <input
                              type="checkbox"
                              checked={preventivoPersonalizzato.servizi.includes(servizio)}
                              onChange={(e) => handleServiziChange(servizio, e.target.checked)}
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                            />
                            <span className="ml-2 text-sm text-gray-700">{servizio}</span>
                          </label>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center py-4">
                        <p className="text-gray-500 text-sm">Caricamento servizi...</p>
                      </div>
                    )}
                  </div>
                  
                  {/* Note */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Note aggiuntive</label>
                    <textarea
                      value={preventivoPersonalizzato.note}
                      onChange={(e) => setPreventivoPersonalizzato(prev => ({ ...prev, note: e.target.value }))}
                      rows="3"
                      className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Inserisci eventuali note o richieste specifiche..."
                    />
                  </div>
                </div>
              </div>
              
              {/* Footer */}
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={creaPreventivoPersonalizzato}
                  disabled={loadingCreazionePreventivoPersonalizzato}
                >
                  {loadingCreazionePreventivoPersonalizzato ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      Creazione...
                    </>
                  ) : (
                    'Crea Preventivo'
                  )}
                </button>
                <button
                  type="button"
                  className="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={closePreventivoPersonalizzato}
                  disabled={loadingCreazionePreventivoPersonalizzato}
                >
                  Annulla
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modale Selezione Vettura Personalizzata */}
      {showSelezioneVetturaPersonalizzata && (
        <div className="fixed inset-0 z-[70] overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
          <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
            
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-5xl sm:w-full">
              {/* Header */}
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 border-b">
                <div className="flex justify-between items-center">
                  <h3 className="text-lg leading-6 font-medium text-gray-900">
                    Seleziona Vettura
                  </h3>
                  <button
                    onClick={() => setShowSelezioneVetturaPersonalizzata(false)}
                    className="text-gray-400 hover:text-gray-500"
                  >
                    <XMarkIcon className="h-6 w-6" />
                  </button>
                </div>
                <p className="text-sm text-gray-600 mt-2">
                  Scegli la vettura per il preventivo personalizzato
                </p>
              </div>
              
              {/* Body */}
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6">
                {/* Filtri avanzati */}
                <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                  <h4 className="text-sm font-semibold text-gray-900 mb-3">Filtri di Ricerca</h4>
                  
                  {/* Prima riga filtri */}
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-3">
                    {/* Ricerca testuale */}
                    <div className="relative">
                      <input
                        type="text"
                        placeholder="Cerca marca, modello..."
                        className="w-full pl-8 pr-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        value={filtriVetturePersonalizzate.search}
                        onChange={(e) => handleFiltroVetturaChange('search', e.target.value)}
                      />
                      <MagnifyingGlassIcon className="h-4 w-4 text-gray-400 absolute left-2 top-1/2 transform -translate-y-1/2" />
                    </div>
                    
                    {/* Marca */}
                    <select
                      value={filtriVetturePersonalizzate.marca_id}
                      onChange={(e) => handleFiltroVetturaChange('marca_id', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="">Tutte le marche</option>
                      {marcheVetture.map(marca => (
                        <option key={marca.id} value={marca.id}>{marca.descrizione}</option>
                      ))}
                    </select>
                    
                    {/* Categoria */}
                    <select
                      value={filtriVetturePersonalizzate.categoria_id}
                      onChange={(e) => handleFiltroVetturaChange('categoria_id', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="">Tutte le categorie</option>
                      {categorieVetture.map(categoria => (
                        <option key={categoria.id} value={categoria.id}>{categoria.descrizione}</option>
                      ))}
                    </select>
                    
                    {/* Tipo */}
                    <select
                      value={filtriVetturePersonalizzate.tipo_id}
                      onChange={(e) => handleFiltroVetturaChange('tipo_id', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="">Tutti i tipi</option>
                      {tipiVetture.map(tipo => (
                        <option key={tipo.id} value={tipo.id}>{tipo.descrizione}</option>
                      ))}
                    </select>
                  </div>
                  
                  {/* Seconda riga filtri */}
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-3 mb-3">
                    {/* Alimentazione */}
                    <select
                      value={filtriVetturePersonalizzate.carburante}
                      onChange={(e) => handleFiltroVetturaChange('carburante', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="">Tutte le alimentazioni</option>
                      <option value="Benzina">Benzina</option>
                      <option value="Diesel">Diesel</option>
                      <option value="Elettrica">Elettrica</option>
                      <option value="Ibrida">Ibrida</option>
                      <option value="Ibrida Benzina">Ibrida Benzina</option>
                      <option value="Ibrida Diesel">Ibrida Diesel</option>
                      <option value="Plugin Hybrid">Plugin Hybrid</option>
                      <option value="GPL">GPL</option>
                      <option value="Metano">Metano</option>
                    </select>
                    
                    {/* Cambio */}
                    <select
                      value={filtriVetturePersonalizzate.cambio}
                      onChange={(e) => handleFiltroVetturaChange('cambio', e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    >
                      <option value="">Tutti i cambi</option>
                      <option value="Manuale">Manuale</option>
                      <option value="Automatico">Automatico</option>
                      <option value="Sequenziale">Sequenziale</option>
                      <option value="CVT">CVT</option>
                    </select>
                    
                    {/* Prezzo minimo */}
                    <input
                      type="number"
                      placeholder="Prezzo min (€)"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      value={filtriVetturePersonalizzate.prezzo_min}
                      onChange={(e) => handleFiltroVetturaChange('prezzo_min', e.target.value)}
                      min="0"
                    />
                    
                    {/* Prezzo massimo */}
                    <input
                      type="number"
                      placeholder="Prezzo max (€)"
                      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      value={filtriVetturePersonalizzate.prezzo_max}
                      onChange={(e) => handleFiltroVetturaChange('prezzo_max', e.target.value)}
                      min="0"
                    />
                  </div>
                  
                  {/* Pulsante reset */}
                  <div className="flex justify-end">
                    <button
                      onClick={resetFiltriVetture}
                      className="px-3 py-1 text-sm text-gray-600 hover:text-gray-800 underline"
                    >
                      Reset filtri
                    </button>
                  </div>
                </div>
                
                {/* Lista vetture */}
                {loadingVetturePersonalizzate ? (
                  <div className="text-center py-8">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
                    <p className="mt-2 text-gray-500">Caricamento vetture...</p>
                  </div>
                ) : (
                  <>
                    {/* Risultati trovati */}
                    <div className="mb-4 text-sm text-gray-600">
                      Trovate {totalResultsVetture} vetture
                    </div>
                    
                    {/* Griglia vetture */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-h-96 overflow-y-auto">
                      {vetturePersonalizzate.map((vettura) => (
                        <div key={vettura.id} className="border border-gray-200 rounded-lg p-4 hover:border-blue-500 transition-colors cursor-pointer" onClick={() => selezionaVetturaPersonalizzata(vettura)}>
                          <div className="flex items-start space-x-3">
                            <div className="flex-1">
                              <h4 className="text-sm font-medium text-gray-900">
                                {vettura.marca?.descrizione} {vettura.modello}
                              </h4>
                              <p className="text-xs text-gray-600 mt-1">
                                {vettura.allestimento}
                              </p>
                              <p className="text-xs text-gray-500">
                                {vettura.alimentazione} - {vettura.cambio}
                              </p>
                              {vettura.prezzo_listino && (
                                <p className="text-sm font-medium text-green-600 mt-2">
                                  €{parseFloat(vettura.prezzo_listino).toLocaleString('it-IT')}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                    
                    {/* Paginazione */}
                    {totalPagesVetture > 1 && (
                      <div className="mt-6 flex justify-center space-x-2">
                        <button
                          onClick={() => handlePageChangeVetture(currentPageVetture - 1)}
                          disabled={currentPageVetture === 1}
                          className="px-3 py-1 text-sm border border-gray-300 rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
                        >
                          Precedente
                        </button>
                        <span className="px-3 py-1 text-sm text-gray-600">
                          Pagina {currentPageVetture} di {totalPagesVetture}
                        </span>
                        <button
                          onClick={() => handlePageChangeVetture(currentPageVetture + 1)}
                          disabled={currentPageVetture === totalPagesVetture}
                          className="px-3 py-1 text-sm border border-gray-300 rounded-md disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50"
                        >
                          Successiva
                        </button>
                      </div>
                    )}
                    
                    {vetturePersonalizzate.length === 0 && (
                      <div className="text-center py-8">
                        <p className="text-gray-500">Nessuna vettura trovata con i filtri selezionati</p>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Modifica Preventivo */}
      {showModificaPreventivoModal && preventivoInModifica && (
        <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
          <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>
            
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full">
              {/* Header */}
              <div className="bg-white px-4 pb-4 sm:p-6 sm:pb-4 border-b">
                <div className="flex justify-between items-center">
                  <h3 className="text-lg leading-6 font-medium text-gray-900">
                    Modifica Preventivo #{preventivoInModifica.id}
                  </h3>
                  <button
                    onClick={() => { setShowModificaPreventivoModal(false); setNuovaVetturaModifica(null); }}
                    className="text-gray-400 hover:text-gray-500"
                  >
                    <XMarkIcon className="h-6 w-6" />
                  </button>
                </div>
                <p className="text-sm text-gray-600 mt-2">
                  Modifica i parametri del preventivo personalizzato
                </p>
              </div>
              
              {/* Body */}
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 max-h-[60vh] overflow-y-auto">
                <div className="space-y-6">
                  
                  {/* Vettura — modificabile dall'admin in revisione */}
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-4 flex items-center justify-between">
                      <span className="flex items-center"><TruckIcon className="h-5 w-5 mr-2 text-blue-600" /> Vettura</span>
                      {ruoloUtente === 'admin' && (
                        <button type="button" onClick={openCambioVetturaModifica}
                          className="text-sm px-3 py-1.5 border border-blue-300 text-blue-700 rounded-lg hover:bg-blue-50 transition-colors">
                          Cambia vettura
                        </button>
                      )}
                    </h4>
                    <div className={`border rounded-lg p-4 ${nuovaVetturaModifica ? 'border-blue-300 bg-blue-50' : 'border-gray-300 bg-gray-50'}`}>
                      <p className="font-medium text-gray-900">
                        {(nuovaVetturaModifica?.marca?.descrizione || nuovaVetturaModifica?.brand || preventivoInModifica.vettura?.brand)} {(nuovaVetturaModifica?.modello || preventivoInModifica.vettura?.modello)}
                      </p>
                      <p className="text-sm text-gray-600">
                        {[(nuovaVetturaModifica?.allestimento || preventivoInModifica.vettura?.allestimento), (nuovaVetturaModifica?.alimentazione || preventivoInModifica.vettura?.alimentazione)].filter(Boolean).join(' · ')}
                      </p>
                      {nuovaVetturaModifica && (
                        <p className="text-xs text-blue-700 mt-2 font-medium">Vettura modificata — verrà salvata con il preventivo</p>
                      )}
                    </div>
                  </div>
                  
                  {/* Parametri principali */}
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                      <ClipboardDocumentListIcon className="h-5 w-5 mr-2 text-green-600" />
                      Parametri Principali
                    </h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Durata (mesi)</label>
                        <select
                          value={datiPreventivoModifica.durata}
                          onChange={(e) => handleDatiPreventivoModificaChange('durata', e.target.value)}
                          className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        >
                          <option value="">Seleziona durata</option>
                          <option value="12">12 mesi</option>
                          <option value="24">24 mesi</option>
                          <option value="36">36 mesi</option>
                          <option value="48">48 mesi</option>
                          <option value="60">60 mesi</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Km Annui</label>
                        <input
                          type="number"
                          value={datiPreventivoModifica.kmAnnui}
                          onChange={(e) => handleDatiPreventivoModificaChange('kmAnnui', e.target.value)}
                          className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                          placeholder="Inserisci km annui"
                          min="1"
                          step="1"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Quantità veicoli</label>
                        <input
                          type="number"
                          value={datiPreventivoModifica.quantita}
                          onChange={(e) => handleDatiPreventivoModificaChange('quantita', e.target.value)}
                          className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                          placeholder="1"
                          min="1"
                          step="1"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Anticipo (€)</label>
                        <input
                          type="number"
                          value={datiPreventivoModifica.anticipo}
                          onChange={(e) => handleDatiPreventivoModificaChange('anticipo', e.target.value)}
                          className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                          placeholder="0"
                          min="0"
                          step="0.01"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Canone Mensile (€)</label>
                        <input
                          type="number"
                          value={datiPreventivoModifica.canone}
                          onChange={(e) => handleDatiPreventivoModificaChange('canone', e.target.value)}
                          className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                          placeholder="0"
                          min="0"
                          step="0.01"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Provvigione (€)</label>
                        <input
                          type="number"
                          value={datiPreventivoModifica.provvigione}
                          onChange={(e) => handleDatiPreventivoModificaChange('provvigione', e.target.value)}
                          className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                          placeholder="0"
                          min="0"
                          step="0.01"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Società di Noleggio</label>
                        <select
                          value={datiPreventivoModifica.societaNoleggio}
                          onChange={(e) => handleDatiPreventivoModificaChange('societaNoleggio', e.target.value)}
                          className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                          disabled={loadingSocietaNoleggio}
                        >
                          <option value="">
                            {loadingSocietaNoleggio ? 'Caricamento società...' : 'Seleziona società'}
                          </option>
                          {!loadingSocietaNoleggio && societaNoleggio.map(societa => (
                            <option key={societa.id} value={societa.nome}>{societa.nome}</option>
                          ))}
                        </select>
                        {loadingSocietaNoleggio && (
                          <div className="mt-1 text-xs text-gray-500 flex items-center">
                            <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-blue-500 mr-1"></div>
                            Caricamento società di noleggio...
                          </div>
                        )}
                        {!loadingSocietaNoleggio && societaNoleggio.length === 0 && (
                          <div className="mt-1 text-xs text-red-500">
                            Nessuna società di noleggio disponibile
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Penali */}
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                      <ExclamationTriangleIcon className="h-5 w-5 mr-2 text-red-600" />
                      Penali
                    </h4>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Penale Kasko</label>
                        <div className="flex space-x-2">
                          <input
                            type="number"
                            value={datiPreventivoModifica.penaleKasko}
                            onChange={(e) => handleDatiPreventivoModificaChange('penaleKasko', e.target.value)}
                            className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            placeholder="0"
                            min="0"
                            step="0.01"
                          />
                          <select
                            value={datiPreventivoModifica.penaleKaskoTipo}
                            onChange={(e) => handleDatiPreventivoModificaChange('penaleKaskoTipo', e.target.value)}
                            className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                          >
                            <option value="euro">€</option>
                            <option value="percentuale">%</option>
                          </select>
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Penale RCA</label>
                        <div className="flex space-x-2">
                          <input
                            type="number"
                            value={datiPreventivoModifica.penaleRCA}
                            onChange={(e) => handleDatiPreventivoModificaChange('penaleRCA', e.target.value)}
                            className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            placeholder="0"
                            min="0"
                            step="0.01"
                          />
                          <select
                            value={datiPreventivoModifica.penaleRCATipo}
                            onChange={(e) => handleDatiPreventivoModificaChange('penaleRCATipo', e.target.value)}
                            className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                          >
                            <option value="euro">€</option>
                            <option value="percentuale">%</option>
                          </select>
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">Penale Furto</label>
                        <div className="flex space-x-2">
                          <input
                            type="number"
                            value={datiPreventivoModifica.penaleFurto}
                            onChange={(e) => handleDatiPreventivoModificaChange('penaleFurto', e.target.value)}
                            className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                            placeholder="0"
                            min="0"
                            step="0.01"
                          />
                          <select
                            value={datiPreventivoModifica.penaleFurtoTipo}
                            onChange={(e) => handleDatiPreventivoModificaChange('penaleFurtoTipo', e.target.value)}
                            className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                          >
                            <option value="euro">€</option>
                            <option value="percentuale">%</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Note */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Note</label>
                    <textarea
                      value={datiPreventivoModifica.note}
                      onChange={(e) => handleDatiPreventivoModificaChange('note', e.target.value)}
                      rows="3"
                      className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Inserisci eventuali note o modifiche..."
                    />
                  </div>

                  {/* Servizi Inclusi */}
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
                      <CheckCircleIcon className="h-5 w-5 mr-2 text-green-600" />
                      Servizi Inclusi
                    </h4>
                    {serviziSistema.length > 0 ? (
                      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                        {serviziSistema.map((servizio) => (
                          <label key={servizio} className="flex items-center">
                            <input
                              type="checkbox"
                              checked={datiPreventivoModifica.servizi.includes(servizio)}
                              onChange={(e) => handleServiziModificaChange(servizio, e.target.checked)}
                              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                            />
                            <span className="ml-2 text-sm text-gray-700">{servizio}</span>
                          </label>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center py-4">
                        <p className="text-gray-500 text-sm">Caricamento servizi...</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              
              {/* Footer */}
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={salvaModifichePreventivo}
                >
                  Salva Modifiche
                </button>
                <button
                  type="button"
                  className="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={() => { setShowModificaPreventivoModal(false); setNuovaVetturaModifica(null); }}
                >
                  Annulla
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TabPreventivi;